import { type Dispatch, createContext, useContext } from 'react'
import { type AppActions } from '@store/reducer'
import { type State } from '@store/defaultReducerState.ts'

const AppContext = createContext<{
	state: State
	dispatch: Dispatch<AppActions>
}>({
	state: {} as State,
	dispatch: () => null,
})

const useAppContext = () => useContext(AppContext)

export { AppContext, useAppContext }
